import { BannerCoupon } from '../../Components';

const LayoutBannerCoupon = () => {
  return (
    <BannerCoupon />
  );
};

export default LayoutBannerCoupon;
